import React, { useEffect } from "react";
import { Footer } from "components/Footer";
import { HeaderWithNav } from "components/HeaderWithNav";
import { HeroSection } from "components/HeroSection";
import { GetStartedSection } from "components/GetStartedSection";
import { useDynamicLanguage } from "hooks/useDynamicLanguage";
import { useScrollToElement } from "hooks/useScrollToElement";
import { LOCALE_STRINGS } from "constants/locales";
import heroImage from "assets/images/solutionFinance.jpg";
import { FinancingSection } from "./components/FinancingSection";
import { FeatureListSectionTwo } from "./components/FeatureListSectionTwo";
import { DecisionDiagramSection } from "./components/DecisionDiagramSection";

export const SolutionsFinance = () => {
  const language = useDynamicLanguage();
  useScrollToElement();


  return (
    <>
      <HeaderWithNav />
      <div id="page" />
      <main className="main-content-wrapper home-page__main">
        <HeroSection
          imageSrc={heroImage}
          language={language}
          getStarted="getStartedFinance"
          titleKey="hero_financeTitle"
          showStarted={true}
          showFooter={true}
        />

        <div 
          className="title-with-subtitle mb-12 text-center mx-auto w-full"
          style={{ maxWidth: "1050px", marginTop: "40px" }}
        >
          <h2 className="title" style={{ maxWidth: "100%" }}>
            {LOCALE_STRINGS[language]?.homePage_solutionsFinance_title}
          </h2>
          <p className="text-small" style={{ maxWidth: "100%" }}>
            {LOCALE_STRINGS[language]?.homePage_solutionsFinance_description}
          </p>
        </div>
        
        <DecisionDiagramSection language={language} />
        <FinancingSection language={language} />
        <FeatureListSectionTwo language={language} />
        <GetStartedSection language={language} />
      </main>
      <Footer />
    </>
  );
};